/**
 * Due to how barbara works, js handles the scrolling when transitioning to pages.
 * Fixes one issue:
 *    1. When scrolled in a page and go to next page, it retains the scroll position in next page.
 * @param {boolean} [once] 
 */
 export function update(once) {
  if (once && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
  }

  window.scrollTo(0, 0)
}

/**
 * Adds a fake scrollbar when transitioning between pages
 * @param {boolean} remove 
 */
export function disable(remove) {
  const user_agents = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  const cond = user_agents.some((toMatchItem) => {return navigator.userAgent.match(toMatchItem)});
  let string = cond ? 'data-scroll-disabled-mobile' : 'data-scroll-disabled';

  if (remove) {
    document.body.removeAttribute(string)
  } else {
    document.body.setAttribute(string, '')
  }
}